module.exports = __webpack_public_path__ + "static/media/foodpanda.c689bec2.png";